import { Injectable, inject } from '@angular/core';

import { Observable, forkJoin, map } from 'rxjs';

import { InitializationResult, UserInitialization } from '@core/models/user-initialization.interface';
import { SysadminApiService } from '@core/services/sysadmin-api.service';

@Injectable({
  providedIn: 'root',
})
export class SysadminInitializationService implements UserInitialization {
  private readonly sysadminApiService = inject(SysadminApiService);

  public initialize(): Observable<InitializationResult> {
    return forkJoin({
      dashboard: this.sysadminApiService.getSysadminDashboard(),
      avatar: this.sysadminApiService.getSysadminAvatar(),
    }).pipe(
      map(({ dashboard, avatar }) => ({
        dashboard,
        avatarUrl: URL.createObjectURL(avatar),
      })),
    );
  }
}
